<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    title="配件出库"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="70%"
    top="5%"
    :close-on-click-modal="false"
  >
    <el-row :gutter="20">
      <el-col :span="16">
        <div class="border-style">基本信息</div>
        <el-form
          :model="item"
          ref="itemform"
          label-width="120px"
          :rules="rules"
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="配件型号名称">
                <el-input
                  v-if="item.DciAccessoryModel"
                  v-model.trim="item.DciAccessoryModel.Name"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="配件型号">
                <el-input
                  v-if="item.DciAccessoryModel"
                  v-model.trim="item.DciAccessoryModel.Number"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="配件SN">
                <el-input v-model.trim="item.SN" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="原SN">
                <el-input v-model.trim="item.OrSN" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="关联产品SN">
                <el-input
                  v-if="item.DciProduct"
                  v-model.trim="item.DciProduct.SN"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="入库日期" prop="StockinAt">
                <el-date-picker
                  v-model="item.StockinAt"
                  style="width: 100%"
                  type="date"
                  disabled
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="出库日期" prop="StockoutAt">
                <el-date-picker
                  v-model="item.StockoutAt"
                  style="width: 100%"
                  type="date"
                  placeholder="请选择日期"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="质保开始日期" prop="QualityStartAt">
                <el-date-picker
                  v-model="item.QualityStartAt"
                  style="width: 100%"
                  type="date"
                  placeholder="请选择日期"
                  @change="changeDate"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="标签" prop="Tags">
                <el-select
                  v-model="item.Tags"
                  :multiple-limit="6"
                  multiple
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择或创建标签"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(tag, index) in tagList"
                    :key="index"
                    :label="tag"
                    :value="tag"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="质保结束日期" prop="QualityEndAt">
                <el-date-picker
                  v-model="item.QualityEndAt"
                  style="width: 100%"
                  type="date"
                  placeholder="请选择日期"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col>
              <el-form-item label="客户名称" prop="ClientName">
                <el-select
                  v-model="item.ClientName"
                  filterable
                  allow-create
                  default-first-option
                  clearable
                  placeholder="请选择或输入客户"
                  style="width: 100%"
                >
                  <el-option
                    v-for="client in clientList"
                    :key="client"
                    :label="client"
                    :value="client"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="出库单号" prop="CheckoutNo">
                <el-input
                  v-model.trim="item.CheckoutNo"
                  placeholder="请输入出库单号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="合同编号" prop="ContractNos">
                <!-- <el-input
                  v-model.trim="item.ContractNo"
                  placeholder="请输入合同编号"
                ></el-input> -->
                <el-select
                  v-model="item.ContractNos"
                  multiple
                  filterable
                  default-first-option
                  clearable
                  placeholder="请选择或输入合同编号"
                  style="width: 100%"
                >
                  <el-option
                    v-for="contract in contractList"
                    :key="contract"
                    :label="contract"
                    :value="contract"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="领用部门" prop="RecipientDeptID">
                <select2
                  style="width: 100%"
                  v-model="item.RecipientDeptID"
                  url="department"
                  :clearable="false"
                  placeholder="请选择部门"
                  no-data-text="没有部门"
                  :urlParams="{
                    where: {},
                  }"
                  q="Name:like"
                  :qinwhere="true"
                  :queryOne="false"
                ></select2>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="领用人" prop="Recipient">
                <el-input
                  v-model.trim="item.Recipient"
                  placeholder="请输入领用人"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="出库经办人" prop="Operator">
                <el-input
                  v-model.trim="item.Operator"
                  placeholder="请输入经办人"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="出库备注" prop="StockoutReason">
            <el-input
              v-model.trim="item.StockoutReason"
              :autosize="{ minRows: 2 }"
              type="textarea"
              placeholder="请输入出库备注"
            ></el-input>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="8">
        <div class="border-style">日志信息</div>
        <div class="dialogDiv">
          <el-timeline :reverse="false">
            <el-timeline-item
              v-for="(activity, index) in activities"
              :key="index"
              :timestamp="
                $sys.dateFormat(activity.UpdatedAt) + ' ' + activity.Operator
              "
              placement="top"
            >
              <el-card>
                <p style="margin-top: 0px; margin-bottom: 0px">
                  {{ activity.Content }}
                </p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-col>
    </el-row>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: _.clone(this.value),
      rules: {
        StockoutAt: [
          { required: true, message: "出库日期不能为空", trigger: "blur" },
        ],
        QualityStartAt: [
          { required: true, message: "质保开始日期不能为空", trigger: "blur" },
        ],
        QualityEndAt: [
          { required: true, message: "质保结束日期不能为空", trigger: "blur" },
        ],
        CheckoutNo: [
          { required: true, message: "出库单号不能为空", trigger: "blur" },
        ],
        ClientName: [
          { required: true, message: "客户名称不能为空", trigger: "blur" },
        ],
        ContractNos: [
          { required: true, message: "合同编号不能为空", trigger: "blur" },
        ],
        // Operator: [
        //   { required: true, message: '出库经办人不能为空', trigger: 'blur' },
        // ],
        RecipientDeptID: [
          { required: true, message: "领用部门不能为空", trigger: "blur" },
        ],
        Recipient: [
          { required: true, message: "领用人不能为空", trigger: "blur" },
        ],
        StockoutReason: [{ max: 64000, message: "内容过多", trigger: "blur" }],
      },
      pager: {
        total: 0,
        page: 1,
        size: -1,
      },
      submitting: false,
      activities: [],
      tagList: [],
      clientList: [],
      contractList: [], //合同
    };
  },
  methods: {
    onOpen() {
      this.item = _.cloneDeep(this.value);

      const date = new Date();
      this.item.StockoutAt = date;
      this.item.QualityStartAt = date;
      this.item.QualityEndAt = new Date(
        date.getTime() + 3600 * 1000 * 24 * 365
      );
      this.item.Operator = this.$store.state.Auth.user.Name;

      this.getLog();
      this.getTagList();
      this.getClientList();
      this.getContractList();
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();
    },
    getLog() {
      this.$axios
        .get(`dci/accessory/${this.item.ID}/record`, {
          params: {
            ...this.pager,
            order: ["-updated_at", "-id"],
          },
        })
        .then((response) => {
          this.activities = response.data.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    getTagList() {
      this.$axios
        .get("dci/accessory/stock-tags")
        .then((response) => {
          this.tagList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    getClientList() {
      this.$axios
        .get("dci/accessory/stock-clients")
        .then((response) => {
          this.clientList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    getContractList() {
      this.$axios
        .get("dci/accessory/stock-contracts")
        .then((response) => {
          this.contractList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    changeDate(val) {
      //质保开始日期修改，质保结束日期也自动修改,默认质保开始日期开始一年
      if (val) {
        const date = this.item.QualityStartAt;
        this.item.QualityEndAt = new Date(
          date.getTime() + 3600 * 1000 * 24 * 365
        );
      } else {
        this.item.QualityEndAt = val;
      }
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit("input", this.item);
        const itemData = { ...this.item };
        // 保存的操作
        this.$axios
          .request({
            url: `dci/accessory/stock-out/${this.item.ID}`,
            method: "put",
            data: itemData,
          })
          .then(() => {
            this.$message.success("出库成功");
            this.submitting = false;
            this.$emit("form:created", true);
            this.$emit("form:saved", true);
            this.$emit("update:visible", false);
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.submitting = false;
            this.$emit("form:created", false);
            this.$emit("form:saved", false);
          });
      });
    },
  },
};
</script>
<style scoped>
.el-divider--horizontal {
  margin: 0px 0 12px 0;
}
.el-timeline {
  margin: 0;
  font-size: 10px;
  list-style: none;
}
.el-card__body {
  padding: 5px;
}
.el-timeline-item__timestamp {
  color: #909399;
  line-height: 1;
  font-size: 8px;
}
.dialogDiv {
  height: 450px;
  overflow: auto;
  padding-left: 10px;
  padding-right: 10px;
}
.border-style {
  height: 28px;
  line-height: 28px;
  border-radius: 0 15px 15px 0;
  border-left: 3px solid #409eff;
  padding-left: 5px;
  margin-bottom: 10px;
  background-color: #ecf5ff;
  color: #409eff;
  font-size: 13px;
  font-weight: bolder;
}
</style>